import { Component, OnInit } from '@angular/core';

import { ApplicationUrls } from 'src/app/configuration/application-urls';
import { MatDialog } from '@angular/material/dialog';
import { ROUTING_URLS } from '@core/constants';
import { Router } from '@angular/router';
import { SharedService } from '@shared/services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  
  constructor(
    private router: Router,
    private sharedService: SharedService,
    private applicationUrls: ApplicationUrls,
    private dialog: MatDialog) { }

  ngOnInit(): void {
   
  }

}
